import { HeartOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useOperationsDashboardContext } from '../../contexts/OperationsDashboardContext';
import styles from '../OperationsDashboard/ops-theme.module.css';

const OpsHandlerTab: FC = () => {
  const { t } = useTranslation('dashboard.OperationsDashboard');
  const { handlerSettings, opsSettings } = useOperationsDashboardContext();

  return (
    <div className={`${styles.placeholderTab} ${styles.animFadeUp}`}>
      <div className={styles.placeholderIcon}>
        <HeartOutlined />
      </div>
      <div className={styles.placeholderTitle}>{t('tabHandler')}</div>
      <div className={styles.placeholderDescription}>
        {t('placeholderDescription')}
      </div>
      {opsSettings.showDebug && handlerSettings && (
        <div className={styles.caption} style={{ marginTop: 16 }}>
          Handler settings loaded: {Object.keys(handlerSettings).length} keys
        </div>
      )}
    </div>
  );
};

export default OpsHandlerTab;
